<template>
  <b-container>
    <b-row>
      <b-col>
        <h4 class="subtitle">Start/End Dates</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="startdate mt-4">
          <label for="start_date">Start Date:</label>
            <datepicker
              class="text-center"
              name="start_date"
              type="date"
              id="start_date"
              v-model="start_date"
            ></datepicker>
        </div>
      </b-col>
      <b-col>
        <div class="enddate mt-4">
          <label for="end_date">End Date:</label>
            <datepicker
              class="text-center"
              name="end_date"
              type="date"
              id="end_date"
              v-model="end_date"
            ></datepicker>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'TeamDates',
  components: {
    Datepicker,
  },
  computed: {
    start_date: {
      get() {
        console.log(this.$store.state.teams.team.start_date);
        return new Date(this.$store.state.teams.team.start_date);        
      },
      set(val) {
        this.$store.commit(`teams/start_date`, val);
      }
    },
    end_date: {
      get() {
        return this.$store.state.teams.team.end_date;        
      },
      set(val) {
        this.$store.commit(`teams/end_date`, val);
      }
    },
  },
};
</script>
